import { CaseStudy, PageQuote } from 'types/generated/contentful'
import CaseStudyCard from './CaseStudyCard'
import { PageQuoteTestimonial } from '../PageQuoteTestimonial'

interface CaseStudyGridProps extends React.HTMLAttributes<HTMLUListElement> {
  caseStudiesAndPageQuotes: Array<CaseStudy | PageQuote>
}

const CaseStudyGrid = ({
  caseStudiesAndPageQuotes,
  className,
  ...props
}: CaseStudyGridProps): JSX.Element => {
  return (
    <ul
      className={`flex flex-wrap flex-col md:flex-row gap-6 md:gap-8 ${
        className || ''
      }`}
      {...props}
    >
      {caseStudiesAndPageQuotes.map((caseStudyOrPageQuote, index) => {
        const cardStyle =
          caseStudyOrPageQuote.__typename === 'CaseStudy'
            ? caseStudyOrPageQuote.cardStyle
            : 'quote-only'

        return (
          <li
            key={`use-case-${caseStudyOrPageQuote.sys?.id ?? index}`}
            className={`md:flex-grow ${
              // Ideally these classes should be created with a reusable function but tailwind doesn't support it
              cardStyle === 'quote-image'
                ? 'md:min-w-[calc((100%-32px*9)/10*7+32px*6)]' // min 7 columns
                : cardStyle === 'quote-stats'
                  ? 'md:min-w-[calc((100%-32px*9)/10*6+32px*5)]' // min 6 columns
                  : cardStyle === 'quote-only'
                    ? 'md:min-w-[calc((100%-32px*9)/10*4+32px*3)]' // min 5 columns
                    : cardStyle === 'stats-only'
                      ? 'md:min-w-[calc((100%-32px*9)/10*3+32px*2)]' // min 4 columns
                      : cardStyle === 'quote-stats-image'
                        ? 'md:min-w-full'
                        : ''
            }`}
            style={{ flexBasis: 0 }}
          >
            {caseStudyOrPageQuote.__typename === 'CaseStudy' ? (
              <CaseStudyCard caseStudy={caseStudyOrPageQuote} />
            ) : caseStudyOrPageQuote.__typename === 'PageQuote' ? (
              <PageQuoteTestimonial pageQuote={caseStudyOrPageQuote} />
            ) : null}
          </li>
        )
      })}
    </ul>
  )
}

export default CaseStudyGrid
